import getSymbolFromCurrency from 'currency-symbol-map';
import { PriceWithDiscount } from '@services';

const formatWithTwoDecimals = (value: number): string => value?.toFixed(2) ?? '';

export const formatPrice = (price: PriceWithDiscount, useDiscountedPrice?: boolean): string | null => {
  if (useDiscountedPrice && !price.discountedValue || !useDiscountedPrice && !price.value) {
    return null;
  }

  return `${getSymbolFromCurrency(price.currencyCode)}${useDiscountedPrice ? formatWithTwoDecimals(price.discountedValue) : formatWithTwoDecimals(price.value)}`;
};
